// extracted by mini-css-extract-plugin
export default {"card":"Encrypted_card__Am7Cf","content":"Encrypted_content__ERymX","faded":"Encrypted_faded__jOTv2","title":"Encrypted_title__-mNHb","svgIcon":"Encrypted_svgIcon__gNFNg"};